import { render, staticRenderFns } from "./SrFilterButtons.vue?vue&type=template&id=f37e834c"
import script from "./SrFilterButtons.vue?vue&type=script&lang=js"
export * from "./SrFilterButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports